<template>
    <div>
        <p>{{ filename }}</p>
    </div>
</template>

<script>
export default {
    name: "file-question-image",
    props: {
        file: {
            type: Object,
            required: true,
        },
    },
    computed: {
        filename() {
            return this.file.filename;
        },
    },
};
</script>